import React from 'react'
import { Divider } from '@mui/material'
import ImportButton from '../importButton/importButton'
import ExportButton from '../exportButton/exportButton'
import SyncPriceButton from '../../global/SyncPriceButton'

const rowsLabel = (count) => `${count} row${count === 1 ? '' : 's'}`

// Turns the replace (array or QM { result, skipped }) and append import responses
// into the rows to display and a notice describing the outcome.
export const summarizeImport = (response, mode) => {
    const rows = Array.isArray(response) ? response : response?.result ?? []
    if (mode === 'append') {
        const { added = 0, updated = 0, duplicates = 0, invalid = 0 } = response ?? {}
        const details = [
            updated > 0 && `${rowsLabel(updated)} updated (SAP metadata and Old price); current prices cleared. Sync all rooftops prices to recalculate`,
            duplicates > 0 && `${rowsLabel(duplicates)} already in the table ignored`,
            invalid > 0 && `${rowsLabel(invalid)} invalid ignored`,
        ].filter(Boolean)
        return {
            rows,
            notice: {
                severity: added + updated === 0 ? 'warning' : details.length ? 'info' : 'success',
                message: `${rowsLabel(added)} added.${details.length ? ` ${details.join(', ')}.` : ''}`,
            },
        }
    }
    const invalid = response?.skipped ?? 0
    return {
        rows,
        notice: {
            severity: invalid > 0 ? 'warning' : 'success',
            message: `Table replaced with ${rowsLabel(rows.length)}.${invalid > 0 ? ` ${rowsLabel(invalid)} invalid skipped.` : ''}`,
        },
    }
}

// Upload (info) and Download (neutral) are file actions; Sync (primary) is the single main action.
export default function RooftopPriceActions({
    api,
    tableLabel,
    exportId,
    data,
    columns,
    fileName,
    sheetName,
    onImportStart,
    onImportSuccess,
    onImportError,
    onSyncComplete,
    onSyncError,
}) {
    const handleImportSuccess = (response, mode) => {
        const { rows, notice } = summarizeImport(response, mode)
        onImportSuccess(rows, notice)
    }

    return (
        <>
            <ImportButton
                api={api}
                tableLabel={tableLabel}
                onStart={onImportStart}
                onSuccess={handleImportSuccess}
                onError={onImportError}
            />
            <ExportButton id={exportId} data={data} columns={columns} fileName={fileName} sheetName={sheetName} />
            <Divider orientation='vertical' flexItem sx={{ mx: 0.5, my: 0.5 }} />
            <SyncPriceButton
                builder='rooftops'
                onSyncComplete={onSyncComplete}
                onError={onSyncError}
                showInlineError={false}
                initialMessage='Sync all rooftops prices'
            />
        </>
    )
}